
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const app = this.$app;
      const $$ = this.$;
      function updateTotal() {
        var selectedTests = $$('input[name="test_ids[]"]:checked');
        var count = selectedTests.length;
        var total = 0;
        selectedTests.each(function () {
          var price = parseFloat($$(this).data('test-price')) || 0;
          total += price;
        });
        $$('#testsCounter').text(count + ' selected');
        $$('#actionBarCount').text(count + (count === 1 ? ' test' : ' tests'));
        $$('#totalAmount').text(total.toFixed(2));
        var bar = $$('#pathlabActionBar');
        if (count > 0) {
          bar.addClass('pl-action-bar-active');
        } else {
          bar.removeClass('pl-action-bar-active');
        }
      }
      updateTotal();
      $$('#pathlabTestsPage').on('change', 'input[name="test_ids[]"]', function () {
        var $tile = $$(this).closest('.pl-test-tile');
        if (this.checked) {
          $tile.addClass('is-checked');
        } else {
          $tile.removeClass('is-checked');
        }
        updateTotal();
      });
      $$('#pathlabTestsPage .add-patient-btn').on('click', function (ev) {
        ev.preventDefault();
        app.popup.open('#pathlabAddPatientPopup');
      });
      $$('#pathlabSaveNewPatient').on('click', function () {
        var name = $$('#pathlabNewPatientName').val().trim();
        var age = $$('#pathlabNewPatientAge').val().trim();
        var gender = $$('#pathlabAddPatientPopup input[name="pathlab_new_patient_gender"]:checked').val();
        if (!name || !age) {
          app.dialog.alert('Please fill all patient details');
          return;
        }
        app.preloader.show();
        app.methods.authHeader();
        app.request({
          url: app.data.remoteUrl + 'patients',
          method: 'POST',
          data: {
            name: name,
            age: age,
            gender: gender
          },
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response.status) {
              var p = response.data;
              var html = '<label class="pl-patient-tile">' + '<input type="radio" name="patient_id" value="' + p.id + '" checked="">' + '<span class="pl-patient-tile-radio"></span>' + '<span class="pl-patient-tile-body">' + '<span class="pl-patient-tile-name">' + p.name + '</span>' + '<span class="pl-patient-tile-meta">' + p.gender + ' \xB7 ' + p.age + ' yrs</span>' + '</span>' + '</label>';
              $$('#pathlabTestsPage input[name="patient_id"]').prop('checked', false);
              var list = $$('#pathlabPatientListArea .pl-patient-list');
              if (list.length === 0) {
                $$('#pathlabPatientListArea .pl-empty-inline').remove();
                $$('#pathlabPatientListArea .pl-add-patient-btn').before('<div class="pl-patient-list"></div>');
                list = $$('#pathlabPatientListArea .pl-patient-list');
              }
              list.append(html);
              app.popup.close('#pathlabAddPatientPopup');
              $$('#pathlabNewPatientName').val('');
              $$('#pathlabNewPatientAge').val('');
              $$('#pathlabAddPatientPopup input[name="pathlab_new_patient_gender"][value="Male"]').prop('checked', true);
              app.toast.create({
                text: 'Patient added',
                closeTimeout: 1800,
                position: 'bottom'
              }).open();
            } else {
              var errorMsg = response.msg || 'Failed to add patient';
              if (response.errors) {
                var msgs = [];
                Object.keys(response.errors).forEach(function (key) {
                  msgs.push(response.errors[key].join(', '));
                });
                errorMsg = msgs.join('\n');
              }
              app.dialog.alert(errorMsg, 'Error');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      });
      $$('#prescriptionDropArea').on('click', function (ev) {
        if (!$$(ev.target).closest('#removeFileBtn').length) {
          $$('#prescriptionFile').click();
        }
      });
      $$('#prescriptionFile').on('change', function () {
        var file = this.files[0];
        if (file) {
          $$('#uploadPlaceholder').hide();
          $$('#uploadPreview').css('display', 'flex');
          $$('#previewFileName').text(file.name);
          if (file.type.startsWith('image/')) {
            var reader = new FileReader();
            reader.onload = function (ev) {
              $$('#previewImage').attr('src', ev.target.result).show();
              $$('#previewFileIcon').hide();
            };
            reader.readAsDataURL(file);
          } else {
            $$('#previewImage').hide();
            $$('#previewFileIcon').show();
          }
        }
      });
      $$('#removeFileBtn').on('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        $$('#prescriptionFile').val('');
        $$('#uploadPreview').hide();
        $$('#uploadPlaceholder').show();
        $$('#previewImage').attr('src', '').hide();
        $$('#previewFileIcon').show();
      });
      function submitBooking() {
        var selectedTests = $$('input[name="test_ids[]"]:checked');
        var patientId = $$('#pathlabTestsPage input[name="patient_id"]:checked').val();
        if (selectedTests.length === 0) {
          app.dialog.alert('Please select at least one test');
          return;
        }
        if (!patientId) {
          app.dialog.alert('Please select a patient');
          return;
        }
        var testIds = [];
        selectedTests.each(function () {
          testIds.push($$(this).val());
        });
        var formData = {
          lab_id: $$('input[name="lab_id"]').val(),
          patient_id: patientId,
          tests: testIds
        };
        app.preloader.show();
        app.methods.authHeader();
        app.request({
          url: app.data.remoteUrl + 'pathology-bookings',
          method: 'POST',
          data: formData,
          dataType: 'json',
          success: function (response) {
            app.preloader.hide();
            if (response && response.status) {
              app.dialog.alert(response.msg || 'Booking successful!', 'Success', function () {
                app.views.main.router.navigate('/lab-bookings/');
              });
            } else {
              app.dialog.alert(response.msg || 'Booking failed. Please try again.', 'Error');
            }
          },
          error: function (xhr) {
            app.preloader.hide();
            app.methods.requestError(xhr);
          }
        });
      }
      $$('#pathlabBookBtn').on('click', function () {
        submitBooking();
      });
      $$('#pathlabBookingForm').on('submit', function (ev) {
        ev.preventDefault();
        submitBooking();
      });
    }
  },
  id: 'e600a402c2',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page pathlab-booking-page" data-name="pathlab-tests" id="pathlabTestsPage">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">';
      r += Template7Helpers.if.call(ctx_1, ctx_1.lab, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.lab.name, ctx_2);
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += 'Book Tests';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <form id="pathlabBookingForm" class="pathlab-booking-form">\n\n                <!-- Lab hero strip -->\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.lab, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="pl-lab-strip">\n                    <div class="pl-lab-strip-icon">\n                        <i class="icon f7-icons if-not-md">testtube</i>\n                        <i class="icon material-icons md-only">biotech</i>\n                    </div>\n                    <div class="pl-lab-strip-body">\n                        <div class="pl-lab-strip-title">';
          r += c(ctx_2.lab.name, ctx_2);
          r += '</div>\n                        <div class="pl-lab-strip-sub">Choose tests and book your slot</div>\n                    </div>\n                </div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n                <!-- Patient selection -->\n                <section class="pl-section">\n                    <div class="pl-section-header">\n                        <span class="pl-section-title">Who is this test for?</span>\n                    </div>\n                    <div class="pl-section-card" id="pathlabPatientListArea">\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.patients, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.patients.length, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="pl-patient-list">\n                            ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.patients, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                            <label class="pl-patient-tile">\n                                <input type="radio" name="patient_id" value="';
                  r += c(ctx_4.id, ctx_4);
                  r += '" ';
                  r += Template7Helpers.if.call(ctx_4, data_4 && data_4.first, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += 'checked=""';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '>\n                                <span class="pl-patient-tile-radio"></span>\n                                <span class="pl-patient-tile-body">\n                                    <span class="pl-patient-tile-name">';
                  r += c(ctx_4.name, ctx_4);
                  r += '</span>\n                                    <span class="pl-patient-tile-meta">';
                  r += c(ctx_4.gender, ctx_4);
                  r += ' \xB7 ';
                  r += c(ctx_4.age, ctx_4);
                  r += ' yrs</span>\n                                </span>\n                            </label>\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                        </div>\n                        ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="pl-empty-inline">No patients added yet. Add one to continue.</div>\n                        ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="pl-empty-inline">No patients added yet. Add one to continue.</div>\n                        ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                        <a href="#" class="pl-add-patient-btn add-patient-btn">\n                            <i class="icon f7-icons if-not-md">plus_circle_fill</i>\n                            <i class="icon material-icons md-only">add_circle</i>\n                            <span>Add new patient</span>\n                        </a>\n                    </div>\n                </section>\n\n                <!-- Tests selection -->\n                <section class="pl-section">\n                    <div class="pl-section-header">\n                        <span class="pl-section-title">Select tests</span>\n                        <span class="pl-section-counter" id="testsCounter">0 selected</span>\n                    </div>\n                    <div class="pl-section-card pl-tests-card">\n                        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.tests, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.tests.length, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <input type="hidden" name="lab_id" value="';
              r += Template7Helpers.if.call(ctx_3, ctx_3.lab, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += c(ctx_4.lab.id, ctx_4);
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '">\n                        <div class="pl-test-list">\n                            ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.tests, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                            <label class="pl-test-tile">\n                                <input type="checkbox" name="test_ids[]" value="';
                  r += c(ctx_4.id, ctx_4);
                  r += '" data-test-price="';
                  r += c(ctx_4.discounted_price, ctx_4);
                  r += '">\n                                <span class="pl-test-tile-check">\n                                    <i class="icon f7-icons if-not-md">checkmark_alt</i>\n                                    <i class="icon material-icons md-only">check</i>\n                                </span>\n                                <span class="pl-test-tile-body">\n                                    <span class="pl-test-tile-row">\n                                        <span class="pl-test-tile-name">';
                  r += c(ctx_4.name, ctx_4);
                  r += '</span>\n                                        <span class="pl-test-tile-price">\u20B9';
                  r += c(ctx_4.discounted_price, ctx_4);
                  r += '</span>\n                                    </span>\n                                    ';
                  r += Template7Helpers.if.call(ctx_4, ctx_4.description, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                                    <span class="pl-test-tile-desc">';
                      r += c(ctx_5.description, ctx_5);
                      r += '</span>\n                                    ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n                                </span>\n                            </label>\n                            ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n                        </div>\n                        ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="pl-empty-inline">No tests available at this lab.</div>\n                        ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                        <div class="pl-empty-inline">No tests available at this lab.</div>\n                        ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    </div>\n                </section>\n\n                <!-- Prescription upload -->\n                <section class="pl-section">\n                    <div class="pl-section-header">\n                        <span class="pl-section-title">Prescription</span>\n                        <span class="pl-section-optional">Optional</span>\n                    </div>\n                    <div class="pl-section-card pl-prescription-card">\n                        <div class="pl-prescription-dropzone" id="prescriptionDropArea">\n                            <div class="pl-prescription-placeholder" id="uploadPlaceholder">\n                                <div class="pl-prescription-icon">\n                                    <i class="icon f7-icons if-not-md">cloud_upload_fill</i>\n                                    <i class="icon material-icons md-only">cloud_upload</i>\n                                </div>\n                                <div class="pl-prescription-title">Tap to upload prescription</div>\n                                <div class="pl-prescription-sub">JPG, PNG or PDF \xB7 max 5 MB</div>\n                            </div>\n                            <div class="pl-prescription-preview" id="uploadPreview" style="display: none;">\n                                <i class="icon material-icons pl-prescription-preview-icon" id="previewFileIcon">insert_drive_file</i>\n                                <img id="previewImage" src="" alt="" class="pl-prescription-preview-image" style="display: none;">\n                                <div class="pl-prescription-preview-meta">\n                                    <div class="pl-prescription-preview-name" id="previewFileName"></div>\n                                    <div class="pl-prescription-preview-hint">Tap to replace</div>\n                                </div>\n                                <a href="#" class="pl-prescription-remove" id="removeFileBtn" aria-label="Remove file">\n                                    <i class="icon material-icons">close</i>\n                                </a>\n                            </div>\n                            <input type="file" name="prescription" id="prescriptionFile" accept="image/*,.pdf" style="display: none;">\n                        </div>\n                    </div>\n                </section>\n\n                <!-- Spacer so the sticky bar doesn\'t cover content -->\n                <div class="pl-sticky-spacer"></div>\n            </form>\n\n            <!-- Sticky bottom action bar -->\n            <div class="pl-action-bar" id="pathlabActionBar">\n                <div class="pl-action-bar-summary">\n                    <div class="pl-action-bar-count" id="actionBarCount">0 tests</div>\n                    <div class="pl-action-bar-total">\u20B9<span id="totalAmount">0</span></div>\n                </div>\n                <button type="button" class="pl-action-bar-btn" id="pathlabBookBtn">\n                    <span>Book now</span>\n                    <i class="icon f7-icons if-not-md">arrow_right</i>\n                    <i class="icon material-icons md-only">arrow_forward</i>\n                </button>\n            </div>\n        </div>\n\n        <!-- Add New Patient Popup -->\n        <div class="popup pathlab-add-patient-popup" id="pathlabAddPatientPopup">\n            <div class="view">\n                <div class="page">\n                    <div class="navbar">\n                        <div class="navbar-inner">\n                            <div class="left">\n                                <a href="#" class="link popup-close" aria-label="Close">\n                                    <i class="icon icon-back"></i>\n                                </a>\n                            </div>\n                            <div class="title">Add New Patient</div>\n                        </div>\n                    </div>\n                    <div class="page-content">\n                        <div class="pl-popup-intro">\n                            <div class="pl-popup-intro-title">New patient details</div>\n                            <div class="pl-popup-intro-sub">This patient will be available for all future bookings.</div>\n                        </div>\n\n                        <div class="pl-form">\n                            <div class="pl-form-field">\n                                <label class="pl-form-label" for="pathlabNewPatientName">\n                                    <span>Name</span>\n                                    <span class="pl-form-required">*</span>\n                                </label>\n                                <input type="text" placeholder="Patient name" id="pathlabNewPatientName">\n                            </div>\n\n                            <div class="pl-form-field">\n                                <label class="pl-form-label" for="pathlabNewPatientAge">\n                                    <span>Age</span>\n                                    <span class="pl-form-required">*</span>\n                                </label>\n                                <input type="number" placeholder="Age in years" id="pathlabNewPatientAge" pattern="[0-9]*" inputmode="numeric">\n                            </div>\n\n                            <div class="pl-form-field">\n                                <span class="pl-form-label">\n                                    <span>Gender</span>\n                                    <span class="pl-form-required">*</span>\n                                </span>\n                                <div class="pl-gender-row">\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" checked="" name="pathlab_new_patient_gender" value="Male">\n                                        <span>Male</span>\n                                    </label>\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" name="pathlab_new_patient_gender" value="Female">\n                                        <span>Female</span>\n                                    </label>\n                                    <label class="pl-gender-pill">\n                                        <input type="radio" name="pathlab_new_patient_gender" value="Other">\n                                        <span>Other</span>\n                                    </label>\n                                </div>\n                            </div>\n\n                            <button type="button" class="pl-popup-save-btn" id="pathlabSaveNewPatient">Save patient</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    